module.exports = __webpack_public_path__ + "img/big_11B01_yellow.992f376f.png";